import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { IrcForms } from "./IrcForms";

function App() {
  return <IrcForms />;
}

export default App;
